import { render, staticRenderFns } from "./FormsList.vue?vue&type=template&id=cbcd50ba&scoped=true&"
import script from "./FormsList.vue?vue&type=script&lang=js&"
export * from "./FormsList.vue?vue&type=script&lang=js&"
import style0 from "./FormsList.vue?vue&type=style&index=0&id=cbcd50ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbcd50ba",
  null
  
)

export default component.exports